// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import PillButton from '../../common/Button/PillButton';

const useStyles = makeStyles(() => ({
  container: {
    border:       '1px solid #CCC',
    padding:      10,
    borderRadius: '5px',
    marginBottom: '12px',
  },
  waypointTypography: {
    margin:     'auto 4px',
    fontWeight: 'bold',
  },
}));

const WayPointEdge = ({ edge, onHighlight, onDeleteEdge }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography>
        Edge from
        <span className={classes.waypointTypography}>{edge.waypointA.id}</span>
        to
        <span className={classes.waypointTypography}>{edge.waypointB.id}</span>
      </Typography>

      <div className="mt-2">
        <PillButton text="Highlight" onClick={() => onHighlight(edge)} />
        <PillButton text="Delete" onClick={() => onDeleteEdge(edge)} btnStyle="delete" className="ml-2" />
      </div>
    </div>
  );
};

WayPointEdge.propTypes = {
  edge:         PropTypes.shape(Object),
  onHighlight:  PropTypes.func,
  onDeleteEdge: PropTypes.func,
};

WayPointEdge.defaultProps = {
  edge:         {},
  onHighlight:  () => {},
  onDeleteEdge: () => {},
};

export default WayPointEdge;
